// Object,Object
// Array,Array
export function fill(arg0, arg1) {
  if (typeof arg0 === 'object' && typeof arg1 === 'object') {
    if (arg0 instanceof Array && arg1 instanceof Array) {
      for (var i in arg1) {
        arg0.push(arg1[i])
      }
    } else if (!(arg0 instanceof Array) && !(arg1 instanceof Array)) {
      for (var key in arg0) {
        if (Object.prototype.hasOwnProperty.call(arg1, key)) {
          arg0[key] = arg1[key]
        }
      }
    }
  }
}
export function join(arr, split) {
  if (arr) {
    return arr.join(split)
  }
}
export function substr(str, start, length) {
  return str.substr(start,length)
}
export function properties(obj) {
  var tmp = obj
  if(tmp) {
    for (var i=1;i<arguments.length;i++){
      if(Object.prototype.hasOwnProperty.call(tmp, arguments[i])){
        if ( tmp[arguments[i]] != null ) {
          tmp = tmp[arguments[i]]
        } else {
          return null
        }
        if(i==arguments.length-1){
          return tmp
        }
      }
    }
  } else {
    return null
  }
}